import { createFileRoute } from "@tanstack/react-router";

import { AuditLogsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/audit-logs")({
  component: AuditLogsPage,
});
